import { createCommand } from '@commander-js/extra-typings';
import type {
  CommandServices,
  GetRootCommandFn,
} from '@wix/cli-command-contract';
import packageJson from '../../package.json' with { type: 'json' };
import { buildCommand } from './build.js';
import { devCommand } from './dev.js';
import { previewCommand } from './preview.js';
import { addPermissionCommand } from './add-permission.js';
import { serveCommand } from './serve.js';
import { generateCommand } from './generate.js';
import { logsCommand } from './logs.js';
import { releaseCommand } from './release.js';

export const getRootCommand: GetRootCommandFn = async (
  services: CommandServices
) => {
  return (
    createCommand('app')
      .version(
        packageJson.version,
        '-v, --version',
        'Output the version number'
      )
      // By default commander doesn't care about positional options
      // so if we had a `--bar` in `wix --bar` root command, or in a `wix foo --bar` sub-command
      // commander would treat them both the same.
      .enablePositionalOptions(true)
      .helpOption('-h, --help', 'Display help for command')
      .helpCommand(false)
      .addCommand(devCommand(services))
      .addCommand(buildCommand(services))
      .addCommand(serveCommand(services), { hidden: true })
      .addCommand(previewCommand(services))
      .addCommand(generateCommand(services))
      .addCommand(logsCommand(services))
      .addCommand(releaseCommand(services))
      .addCommand(addPermissionCommand(services), { hidden: true })
  );
};
